import script from "./DiagTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagTab.vue?vue&type=script&setup=true&lang=js"

import "./DiagTab.vue?vue&type=style&index=0&id=28e28560&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e28560"]])

export default __exports__